<template>
  <div>
    <product-form />
  </div>
</template>

<script>
import productForm from '../components/Form.vue'
export default {
name: "Add",
  components: {
    productForm,
  },
}
</script>